import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { JJamesAlertComponent, JJamesCardComponent, JjamesButtonComponent } from 'shared-lib';
import { ParkingZoneService } from '../../../api/gen/api/parkingZone.service';
import { ParkingZoneDto } from '../../../api/gen/model/parkingZoneDto';

@Component({
  selector: 'app-delete-parking-zone',
  imports: [
    CommonModule,
    JjamesButtonComponent,
    JJamesCardComponent,
    JJamesAlertComponent
  ],
  templateUrl: './delete-parking-zone.component.html',
  styleUrl: './delete-parking-zone.component.scss'
})
export class DeleteParkingZoneComponent implements OnInit {
  isDeleting = false;
  isLoading = true;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  zoneId: string | null = null;
  currentZone: ParkingZoneDto | null = null;

  constructor(
    private parkingZoneService: ParkingZoneService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.zoneId = this.route.snapshot.paramMap.get('zoneId');
    if (this.zoneId) {
      this.loadZone();
    } else {
      this.router.navigate(['/parking-spaces']);
    }
  }

  private loadZone(): void {
    if (!this.zoneId) return;

    this.isLoading = true;
    this.parkingZoneService.parkingZoneParkingZoneIdGet(this.zoneId).subscribe({
      next: (response: any) => {
        this.currentZone = response;
        this.isLoading = false;
      },
      error: (error: any) => {
        this.errorMessage = 'Failed to load parking zone details' + error.error;
        this.isLoading = false;
        console.error('Error loading zone:', error);
      }
    });
  }

  onConfirmDelete(): void {
    if (!this.zoneId) return;

    this.isDeleting = true;
    this.errorMessage = null;

    this.parkingZoneService.parkingZoneDelete(this.zoneId).subscribe({
      next: (response) => {
        if (response) {
          this.successMessage = 'Parking zone deleted successfully!';
          this.isDeleting = false;
          // Navigate back after a short delay to show success message
          setTimeout(() => {
            this.onCancel();
          }, 2000);
        }
      },
      error: (error: any) => {
        this.errorMessage = 'Failed to delete parking zone.' + error.error;
        this.isDeleting = false;
        console.error('Error deleting zone:', error);
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/parking-spaces']);
  }

  getZoneAddressString(): string {
    if (!this.currentZone?.address) return 'No address specified';

    const address = this.currentZone.address;
    const parts = [
      address.firstAddressLine,
      address.secondAddressLine,
      address.locality,
      address.postCode,
      address.region
    ].filter(part => part && part.trim());

    return parts.length > 0 ? parts.join(', ') : 'No address specified';
  }
}
